module.exports = __webpack_public_path__ + "img/15.f6d84e9b.jpg";